function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PersistentTooltip from '../../persistent-tooltip';
import { pickValidValues } from '../../../helpers/components-helpers';
import ErrorMessage from './error';
import Label from './label';
import InputField from './input-field';
import { Description, InputGroup, Underline } from './style';
import { getCurrentError, validate } from './error/utils';

class TextInput extends Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "formatChars", {
      '9': '[0-9]',
      a: '[a-zA-Z]',
      '*': '[a-zA-Z0-9]',
      c: '[0-9.]'
    });

    _defineProperty(this, "state", {
      errors: Object.assign(validate(this.props.value !== null && this.props.value !== undefined ? this.props.value.toString() : '', this.props.options), {
        customError: this.props.error
      }),
      value: this.props.value !== undefined ? this.props.value : '',
      isFocused: !!this.props.isFocused,
      enableError: !!this.props.enableError,
      justClosedTooltip: false,
      cursorPosition: 0,
      isInfoTooltipOpen: false
    });

    _defineProperty(this, "inputRef", /*#__PURE__*/React.createRef());

    _defineProperty(this, "infoTooltipAnimationTimeout", 0);

    _defineProperty(this, "_onFocus", () => {
      this.setState({
        isFocused: true
      });
      clearTimeout(this.infoTooltipAnimationTimeout);
      this.infoTooltipAnimationTimeout = window.setTimeout(() => {
        // We need timeout here in order to change the state after label animation is done
        // The time should be 150ms since the animation time is 130ms
        this.setState({
          isInfoTooltipOpen: true
        }); // TODO: This timeout SHOULD be 150ms, but is 0 because there is a bug in rc-tooltip usage
        // which causes the tooltip to render for 100ms on input focus
        // When rc-tooltip usage is fixed, this should be changed to 150ms
      }, 0);
    });

    _defineProperty(this, "_onBlur", event => {
      this.setState({
        isFocused: false,
        isInfoTooltipOpen: false
      });
      clearTimeout(this.infoTooltipAnimationTimeout);

      if (this.props.onBlur) {
        this.props.onBlur(event);
      }

      this._onBlurChange(event);

      this._handleError(event.target.name);
    });

    _defineProperty(this, "_onKeyPress", event => {
      var {
        onKeyPress
      } = this.props;

      if (onKeyPress) {
        onKeyPress(event);
      }
    });

    _defineProperty(this, "getPassBackValue", eventValue => {
      var {
        options
      } = this.props;
      var {
        returnUnmaskedValue = false,
        mask = ''
      } = options;
      var passBackValue = eventValue;

      if (returnUnmaskedValue) {
        var maskValues = Object.keys(this.formatChars).join('').replace(/([\*])/g, '\\\\$1');
        var maskRegex = new RegExp("[".concat(maskValues, "\\s]+?"), 'g');
        var modMask = mask.split(maskRegex).filter(m => !!m).map(m => m.trim());
        passBackValue = modMask.reduce((val, replace) => val.replace(replace, '').replace(/[\s,]/g, ''), eventValue);
      }

      return passBackValue;
    });

    _defineProperty(this, "_onBlurChange", event => {
      var {
        onBlurChange
      } = this.props;
      var {
        name,
        value
      } = event.target;

      if (onBlurChange) {
        onBlurChange({
          name,
          value: this.getPassBackValue(value)
        });
      }
    });

    _defineProperty(this, "_onChange", event => {
      var {
        onChange,
        options,
        validateOnChange
      } = this.props;
      var {
        value: stateValue
      } = this.state;
      var {
        name,
        value,
        selectionStart
      } = event.target;

      if (value === stateValue) {
        return;
      }

      var passBackValue = this.getPassBackValue(value);
      var errors = validate(passBackValue, options);
      this.setState({
        enableError: false,
        errors,
        justClosedTooltip: false
      }, () => {
        if (validateOnChange) {
          this._handleError(name);
        }

        this.setState({
          value: value,
          cursorPosition: selectionStart,
          isInfoTooltipOpen: false
        });
        clearTimeout(this.infoTooltipAnimationTimeout); // TODO: For the validateOnChange case, consider passing back the error as part of the onChange.

        if (onChange) {
          onChange({
            name,
            value: passBackValue
          });
        }
      });
    });

    _defineProperty(this, "_onTooltipCloseButtonClick", () => {
      this.setState({
        justClosedTooltip: true
      });
    });

    _defineProperty(this, "getInputValue", () => {
      var {
        value: propValue
      } = this.props;
      var {
        value: stateValue
      } = this.state;
      var inputValue = '';

      if (propValue !== stateValue && stateValue !== null && stateValue !== undefined) {
        inputValue = stateValue.toString();
      } else if (propValue !== null && propValue !== undefined) {
        inputValue = propValue.toString();
      }

      return inputValue;
    });
  }

  resetCursorPosition() {
    if (this.inputRef && this.inputRef.current && this.inputRef.current.selectionStart && this.state.cursorPosition) {
      if (this.inputRef.current.selectionStart > this.state.cursorPosition) {
        this.inputRef.current.selectionStart = this.inputRef.current.selectionEnd = this.state.cursorPosition;
      }
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    var _this$state = this.state,
        {
      errors
    } = _this$state,
        stateValues = _objectWithoutProperties(_this$state, ["errors"]);

    var _this$props = this.props,
        {
      options
    } = _this$props,
        propValues = _objectWithoutProperties(_this$props, ["options"]);

    var compare = (a, b) => Object.keys(a).every(key => a[key] === b[key]);

    if (Object.keys(errors).length !== Object.keys(nextState.errors).length) {
      return true;
    }

    var hasSameErrors = compare(nextState.errors, errors);
    var hasSameState = compare(stateValues, nextState);
    var hasSameProps = compare(propValues, nextProps);
    var hasSameOptions = compare(nextProps.options, options);
    return !hasSameErrors || !hasSameState || !hasSameOptions || !hasSameProps;
  }

  componentDidUpdate(previousProps) {
    // Update the error message if we receive a custom error
    var {
      error: previousError,
      enableError: previousEnableError,
      value: previousValue,
      initiateValidate: previousInitiateValidate
    } = previousProps;
    var {
      error,
      enableError,
      value,
      initiateValidate,
      name
    } = this.props;
    var {
      errors
    } = this.state;
    var newState = {};

    if (enableError && enableError !== previousEnableError) {
      newState.enableError = true;
    }

    if (previousError !== error) {
      var newErrorsState = _objectSpread(_objectSpread({}, errors), {}, {
        customError: error
      });

      newState.errors = newErrorsState;
      newState.enableError = true;
    }

    var shouldValidate = previousValue !== value || previousInitiateValidate !== initiateValidate;

    if (newState.enableError !== false && shouldValidate) {
      var errorsFromUpdatedValue = validate(value !== null && value !== undefined ? value.toString() : '', this.props.options);
      newState.errors = _objectSpread(_objectSpread({}, errorsFromUpdatedValue), {}, {
        customError: error
      });
      var evaluatedError = getCurrentError(newState.errors);

      if (this.props.onError && evaluatedError) {
        this.props.onError({
          name: name,
          error: evaluatedError
        });
      }
    }

    if (previousValue !== value) {
      newState.value = value;
    }

    if (Object.keys(newState).length) {
      this.setState(prevState => _objectSpread(_objectSpread({}, prevState), newState));
    }

    if (this.inputRef && this.state.cursorPosition) {
      this.resetCursorPosition();
    }
  }

  get currentError() {
    var {
      errors
    } = this.state;
    return getCurrentError(errors);
  }

  _handleError(name) {
    this.setState({
      enableError: true
    });

    if (this.props.onError && typeof this.currentError === 'string') {
      this.props.onError({
        name: name,
        error: this.currentError
      });
    }
  }

  // eslint-disable-next-line complexity
  render() {
    var {
      label,
      unfocusedLabel,
      focusedLabel,
      name,
      type = 'text',
      options,
      beforeMaskedValueChange,
      autoComplete,
      onClick,
      disableErrorMessage,
      readOnly,
      interactableReadOnly,
      hasInlineIcon: hasInlineIconProp,
      hasInlinePlusMinusIconButtons,
      disableErrorXIcon,
      textSize,
      unfocusedLabelTextSize,
      forwardRef,
      className,
      onInfoIconClick,
      tooltipConfig,
      enableInfoIconTooltip
    } = this.props;
    var {
      isFocused,
      enableError,
      value: stateValue
    } = this.state;
    var isActive = isFocused || stateValue !== null && stateValue !== undefined && stateValue !== '';
    var hasError = !!this.currentError;
    var optionsWithValidValue = pickValidValues(options);
    var {
      mask = '',
      maskChar = null
    } = optionsWithValidValue;
    var inputValue = this.getInputValue();
    var unfocusedLabelTextSizeValue = unfocusedLabelTextSize || textSize;
    var tooltipContent = '';
    var showTooltip = false;
    var enableTriggerTooltip;

    if (tooltipConfig) {
      tooltipContent = tooltipConfig.tooltipContent;
      showTooltip = tooltipContent && tooltipConfig.tooltipEnabled && !this.state.justClosedTooltip || false;
      enableTriggerTooltip = tooltipContent && tooltipConfig.enableTriggerTooltip && !showTooltip || false;
    }

    var showError = hasError && enableError;
    var hasInlineIcon = hasInlineIconProp || !!onInfoIconClick && !this.state.isFocused && inputValue === '' || interactableReadOnly || showError;
    var dangerouslySetOverlayInnerHTML = tooltipConfig && tooltipConfig.dangerouslySetOverlayInnerHTML;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputGroup, {
      className: className,
      "data-test-id": this.props.name
    }, /*#__PURE__*/React.createElement(PersistentTooltip, {
      onTooltipCloseButtonClick: this._onTooltipCloseButtonClick,
      tooltipContent: tooltipContent,
      show: showTooltip
    }), /*#__PURE__*/React.createElement(InputField, {
      name: name,
      mask: mask,
      type: type,
      maskChar: maskChar,
      formatChars: this.formatChars,
      beforeMaskedValueChange: beforeMaskedValueChange,
      value: inputValue,
      onChange: this._onChange,
      onKeyPress: this._onKeyPress,
      onBlur: this._onBlur,
      onFocus: this._onFocus,
      onClick: onClick,
      showError: showError,
      autoComplete: autoComplete,
      readOnly: readOnly,
      isFocused: isFocused,
      interactableReadOnly: interactableReadOnly,
      hasInlineIcon: hasInlineIcon,
      disableErrorXIcon: disableErrorXIcon,
      hasInlinePlusMinusIconButtons: hasInlinePlusMinusIconButtons,
      textSize: textSize,
      forwardRef: forwardRef || this.inputRef,
      onInfoIconClick: onInfoIconClick,
      enableTriggerTooltip: enableTriggerTooltip,
      tooltipContent: tooltipContent,
      dangerouslySetOverlayInnerHTML: dangerouslySetOverlayInnerHTML,
      enableInfoIconTooltip: enableInfoIconTooltip
    }), /*#__PURE__*/React.createElement(Underline, {
      isActive: isFocused,
      readOnly: readOnly,
      interactableReadOnly: interactableReadOnly
    }), /*#__PURE__*/React.createElement(Label, {
      htmlFor: name,
      hasInlinePlusMinusIconButtons: hasInlinePlusMinusIconButtons,
      hasInlineIcon: hasInlineIcon,
      label: label,
      focusedLabel: focusedLabel,
      unfocusedLabel: unfocusedLabel,
      unfocusedLabelTextSize: unfocusedLabelTextSizeValue,
      isActive: readOnly || isActive,
      onInfoIconClick: onInfoIconClick,
      enableInfoIconTooltip: enableInfoIconTooltip,
      tooltipContent: tooltipContent,
      dangerouslySetOverlayInnerHTML: dangerouslySetOverlayInnerHTML,
      isInfoTooltipOpen: this.state.isInfoTooltipOpen
    }), this.props.description && /*#__PURE__*/React.createElement(Description, null, this.props.description), /*#__PURE__*/React.createElement(ErrorMessage, {
      enableError: enableError,
      error: this.currentError,
      disableErrorMessage: disableErrorMessage
    }), this.props.children));
  }

}

_defineProperty(TextInput, "defaultProps", {
  name: Date.now().toString(),
  options: {},
  value: '',
  error: null,
  enableError: false
});

export default TextInput;